import { capitalize } from "lodash";
import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { FramerTooltip } from "@ryde/controls";
import { usePageContext } from "@ryde/redux";
import {
  displayedRidesSeatsCountSF,
  displayedRowsCountSF,
  TOOLTIP_DELAY_BUTTONS,
  useIsMobile,
} from "@ryde/shared";

import { EditGridColumnButton, PanelTopRightStatItem } from "../elements";
import {
  CarIcon,
  PanelStatStyled,
  PassengerIcon,
} from "./panel-top.stat.styled";

interface IPanelTopStatRidesLiveMapProps {
  leftComponent?: ReactNode;
}

export const PanelTopStatRidesLiveMap: FC<IPanelTopStatRidesLiveMapProps> = ({
  leftComponent,
}) => {
  const { isMobile } = useIsMobile();
  const { entity } = usePageContext();
  const seatsCount = useRecoilValue(displayedRidesSeatsCountSF(entity));
  const ridesCount = useRecoilValue(displayedRowsCountSF(entity));
  const { t } = useTranslation();

  return (
    <PanelStatStyled>
      {Boolean(isMobile) && Boolean(leftComponent) && (
        <div className="container_start">{leftComponent}</div>
      )}
      <FramerTooltip
        content={capitalize(t("ride.PASSENGERS"))}
        mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
      >
        <span>
          <PanelTopRightStatItem
            e2eId="stat-rides-passengers-count-map"
            hideSelected
            total={seatsCount}
            label={<PassengerIcon />}
          />
        </span>
      </FramerTooltip>
      <FramerTooltip
        content={capitalize(t("ride.VEHICLES"))}
        mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
      >
        <span>
          <PanelTopRightStatItem
            hideSelected
            e2eId="stat-rides-count-map"
            total={ridesCount}
            label={<CarIcon />}
          />
        </span>
      </FramerTooltip>
      {Boolean(isMobile) && (
        <div className="stat_panel_end">
          <EditGridColumnButton />
        </div>
      )}
    </PanelStatStyled>
  );
};
